import { Dashboard } from '@/common/dashboard/Dashboard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { BestPriceTopDiscCard } from '../../bestPrice/dashboard/BestPriceTopDiscCard';

// Selections are limited to the Products, Customers, and Contracts that have Best Prices
const entityFilterFieldDefs = [
  {
    field: 'prodExpr',
    displayName: 'Products',
    entity: 'PROD',
    code: 'PROD',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'AES_BEST_PRICE',
    parentFilterFkField: 'prodId',
  },
  {
    field: 'custExpr',
    displayName: 'Customers',
    entity: 'CUST',
    code: 'CUST',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'AES_BEST_PRICE',
    parentFilterFkField: 'custId',
  },
  {
    field: 'ctrtExpr',
    displayName: 'Contracts',
    entity: 'CTRT',
    code: 'CTRT',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'AES_BEST_PRICE',
    parentFilterFkField: 'ctrtId',
  },
];

const defaultFormValues = {
  prodExpr: null,
  custExpr: null,
  ctrtExpr: null,
};

export const BestPriceDashboard = () => {
  return (
    <Dashboard
      title="Best Price Dashboard"
      titleIcon={fas.faChartBar}
      module="sc"
      defaultFormValues={defaultFormValues}
    >
      <FilterContainer>
        {entityFilterFieldDefs.map((fieldDef) => (
          <EntitySelect key={fieldDef.field} fieldDef={{ ...fieldDef, variant: 'outlined' }} />
        ))}
      </FilterContainer>
      <SpacerLayout>
        <Spacer vertical>
          <BestPriceTopDiscCard />
        </Spacer>
      </SpacerLayout>
    </Dashboard>
  );
};
